import { RouteRecordRaw } from 'vue-router'

export default {
	path: '/bill-of-lading',
	meta: {
		title: 'shared.billOfLading'
	},
	children: [
		{
			path: 'warehouse',
			meta: {
				title: 'shared.billOfLadingWarehouse'
			},
			component: {
				name: 'BillOfLadingWarehouseWrapper',
				render() {
					return h(resolveComponent('router-view'))
				}
			},
			children: [
				{
					path: '',
					name: 'BillOfLadingWarehouseReport',
					component: () => import('../pages/WarehouseReport.vue')
				},
				{
					path: ':id',
					name: 'BillOfLadingWarehouseDetail',
					component: () => import('../pages/detail.vue'),
					meta: {
						title: 'shared.billOfLadingDetail',
						dynamicBreadcrumb: 'billOfLadingNumber'
					}
				}
			]
		},
		{
			path: 'ready-to-process',
			meta: {
				title: 'shared.billsReadyToProcessing'
			},
			component: {
				name: 'BillOfLadingReadyToProcessWrapper',
				render() {
					return h(resolveComponent('router-view'))
				}
			},
			children: [
				{
					path: '',
					name: 'BillOfLadingReadyToProcessReport',
					component: () => import('../pages/ReadyToProcessReport.vue')
				},
				{
					path: ':id',
					name: 'BillOfLadingReadyToProcessDetail',
					component: () => import('../pages/detail.vue'),
					meta: {
						title: 'shared.billOfLadingDetail',
						dynamicBreadcrumb: 'billOfLadingNumber'
					}
				}
			]
		},
		{
			path: 'processing',
			meta: {
				title: 'shared.billsProcessing'
			},
			component: {
				name: 'BillOfLadingProcessingWrapper',
				render() {
					return h(resolveComponent('router-view'))
				}
			},
			children: [
				{
					path: '',
					name: 'BillOfLadingProcessingReport',
					component: () => import('../pages/ProcessingReport.vue')
				},
				{
					path: ':id',
					name: 'BillOfLadingProcessingDetail',
					component: () => import('../pages/detail.vue'),
					meta: {
						title: 'shared.billOfLadingDetail',
						dynamicBreadcrumb: 'billOfLadingNumber'
					}
				}
			]
		},
		{
			path: 'waiting-to-pay',
			meta: {
				title: 'shared.waitingToPay'
			},
			component: {
				name: 'BillOfLadingWaitingToPayWrapper',
				render() {
					return h(resolveComponent('router-view'))
				}
			},
			children: [
				{
					path: '',
					name: 'BillOfLadingWaitingToPayReport',
					component: () => import('../pages/WaitingToPayReport.vue')
				},
				{
					path: ':id',
					name: 'BillOfLadingWaitingToPayDetail',
					component: () => import('../pages/detail.vue'),
					meta: {
						title: 'shared.billOfLadingDetail',
						dynamicBreadcrumb: 'billOfLadingNumber'
					}
				},
				{
					path: 'payment-queue-confirm',
					name: 'PaymentConfirmPage',
					component: () => import('../pages/PaymentConfirmReport.vue')
				}
			]
		},
		{
			path: 'payment-failed',
			meta: {
				title: 'shared.paymentFailed'
			},
			component: {
				name: 'BillOfLadingPaymentFailedWrapper',
				render() {
					return h(resolveComponent('router-view'))
				}
			},
			children: [
				{
					path: '',
					name: 'BillOfLadingPaymentFailedReport',
					component: () => import('../pages/PaymentFailedReport.vue')
				},
				{
					path: ':id',
					name: 'BillOfLadingPaymentFailedDetail',
					component: () => import('../pages/detail.vue'),
					meta: {
						title: 'shared.billOfLadingDetail',
						dynamicBreadcrumb: 'billOfLadingNumber'
					}
				}
			]
		},
		{
			path: 'payment-success',
			meta: {
				title: 'shared.paymentSuccess'
			},
			component: {
				name: 'BillOfLadingPaymentSuccessWrapper',
				render() {
					return h(resolveComponent('router-view'))
				}
			},
			children: [
				{
					path: '',
					name: 'BillOfLadingPaymentSuccessReport',
					component: () => import('../pages/PaymentSuccessReport.vue')
				},
				{
					path: ':id',
					name: 'BillOfLadingPaymentSuccessDetail',
					component: () => import('../pages/detail.vue'),
					meta: {
						title: 'shared.billOfLadingDetail',
						dynamicBreadcrumb: 'billOfLadingNumber'
					}
				}
			]
		},
		{
			path: 'payment-queue',
			meta: {
				title: 'shared.paymentQueue'
			},
			component: {
				name: 'BillOfLadingPaymentQueueWrapper',
				render() {
					return h(resolveComponent('router-view'))
				}
			},
			children: [
				{
					path: '',
					name: 'BillOfLadingPaymentQueueReport',
					component: () => import('../pages/PaymentQueueReport.vue')
				},
				{
					path: ':id',
					name: 'BillOfLadingPaymentQueueDetail',
					component: () => import('../pages/detail.vue'),
					meta: {
						title: 'shared.billOfLadingDetail',
						dynamicBreadcrumb: 'billOfLadingNumber'
					}
				}
			]
		}
	]
} as RouteRecordRaw
